import { __rest } from "tslib";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const Facebook = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M20,12 C20,7.58171875 16.4182812,4 12,4 C7.58171875,4 4,7.58171875 4,12 C4,15.9930312 6.92548437,19.3026562 10.75,19.9028125 L10.75,14.3125 L8.71875,14.3125 L8.71875,12 L10.75,12 L10.75,10.2375 C10.75,8.2325 11.9443437,7.125 13.7717187,7.125 C14.6469844,7.125 15.5625,7.28125 15.5625,7.28125 L15.5625,9.25 L14.5537187,9.25 C13.5599219,9.25 13.25,9.86667187 13.25,10.4993281 L13.25,12 L15.46875,12 L15.1140625,14.3125 L13.25,14.3125 L13.25,19.9028125 C17.0745156,19.3026562 20,15.9930312 20,12", fillRule: "evenodd" })));
};
Facebook.displayName = 'Facebook';
export default Facebook;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Facebook.js.map